<template>
    <c-chart :data="data" :options="options" :type="type"/>
</template>
<script setup>
import {CChart} from "@coreui/vue-chartjs";

defineProps(['data', 'type', 'options']);
</script>
